import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { categoryKindIcon, type RefDataItem as Item } from '@/foundations/helpers/refDataFilters';

type Props = {
  value: string[];
  items: Item[];
  itemText: string;
  label: string;
  colorOf?: (item: Item) => string | undefined;
  displayOf?: (item: Item) => string;
  selectAll?: boolean;
};
type Emits = {
  (e: 'input', ids: string[]): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'RefDataAutocomplete',
  props: {
    value: null,
    items: null,
    itemText: null,
    label: null,
    colorOf: null,
    displayOf: null,
    selectAll: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', ids: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string[];
  items: Item[];
  itemText: string;
  label: string;
  colorOf?: (item: Item) => string | undefined;
  displayOf?: (item: Item) => string;
  selectAll?: boolean;
}





const search = ref('');

const selected = computed({
  get: () => props.value,
  set: (ids: string[]) => emit('input', ids),
});

const textOf = (item: Item) => (props.displayOf ? props.displayOf(item) : String(item[props.itemText] ?? ''));
const colorFor = (item: Item) => props.colorOf?.(item);
const isSelected = (id: string) => props.value.includes(id);

const allSelected = computed(() => props.items.length > 0 && props.value.length === props.items.length);
const toggleAll = () => emit('input', allSelected.value ? [] : props.items.map((item) => item.id));
const remove = (id: string) => emit('input', props.value.filter((selectedId) => selectedId !== id));

return { __sfc: true,props, emit, search, selected, textOf, colorFor, isSelected, allSelected, toggleAll, remove, categoryKindIcon }
}

})